<template>
  <div class="article-container">
    <div class="article-title">{{articles.publishTitle}}</div>
    <div class="article-content">
      <p v-html="articles.publishContent" style="width:800px;"></p>
    </div>
  </div>
</template>
<script>
import { getArticleDetail } from '@/apis/article'
export default {
  data () {
    return {
      articles: {}
    }
  },
  mounted () {
    let id = this.$route.params.id
    getArticleDetail(id).then(res => {
      console.log(res)
      if (res.data.state === 1) {
        this.articles = res.data.attribute
      }
    })
  }
}
</script>
<style lang="less" scoped>
//@import url("../../assets/article-details.less");
.article-container {
  .article-title {
    display: flex;
    justify-content: center;
    font-size: 26px;
    font-weight: 600;
  }
  .article-content {
    display: flex;
    justify-content: center;
    padding: 20px;
    font-size: 16px;
  }
}

.article-content /deep/ img {
  display: block;
  max-width: 480px;
  margin: 0 auto;
  padding: 10px;
}
</style>
